import { SupportedModel } from "@src/gql/graphql";

const SUPPORTED_MODEL_VALUES = new Set<string>(Object.values(SupportedModel));

/** Uppercase identifier shape used by backend model ids. */
const MODEL_ID_PATTERN = /^[A-Z][A-Z0-9_]*$/;

/** GraphQL enum member. */
export function isSupportedModel(value: unknown): value is SupportedModel {
	return typeof value === "string" && SUPPORTED_MODEL_VALUES.has(value);
}

/**
 * Backend model id on a card shape — enum member or dynamic id not yet in
 * codegen. Use at shape/API string boundaries before presentation helpers.
 */
export function isModelId(value: unknown): value is SupportedModel {
	if (typeof value !== "string" || value.length === 0) {
		return false;
	}

	return isSupportedModel(value) || MODEL_ID_PATTERN.test(value);
}

export function parseModelId(value: unknown): SupportedModel | undefined {
	return isModelId(value) ? value : undefined;
}
